import React from "react";
import renderRoutesMap from "./renderRoutesMap";
import { Routes } from "react-router-dom";

const renderRoutes = ({ routes, extraProps = {}, routeProps = {} }) => (
  <Routes>
    {renderRoutesMap(routes, extraProps)}
  </Routes>
);

export default renderRoutes;
